import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import { types as loginTypes } from '../auth/login';

export const INITIAL_STATE = {
  getPreferences: {
    fetching: false,
    fetched: false,
    error: null,
  },
  preferences: {
    coupon_search_range: null,
    categories: [],
  },
};

const { Types, Creators } = createActions(
  {
    getPreferences: [],
    getPreferencesRequest: [],
    getPreferencesSuccess: ['data'],
    getPreferencesFailure: ['error'],
    updatePreferences: ['data', 'resolve'],
    updatePreferencesRequest: [],
    updatePreferencesSuccess: ['data'],
    updatePreferencesFailure: ['error'],
  },
  { prefix: 'cb/customerPreferences/' },
);

export { Types as types, Creators as actions };

const getRequest = state => ({
  ...state,
  getPreferences: { ...state.getPreferences, fetching: true, error: null },
});

const getSuccess = (state, { data }) => ({
  ...state,
  getPreferences: { fetching: false, fetched: true, error: null },
  preferences: data,
});

const getFailure = (state, { error }) => ({
  ...state,
  getPreferences: { fetching: false, fetched: true, error },
});

const updateRequest = state => ({
  ...state,
  getPreferences: { ...state.getPreferences, fetching: true },
});

const updateSuccess = (state, { data }) => ({
  ...state,
  getPreferences: { ...state.getPreferences, fetching: false },
  preferences: { ...state.preferences, ...data },
});

const updateFailure = state => ({
  ...state,
  getPreferences: { ...state.getPreferences, fetching: false },
});

export const HANDLERS = {
  [Types.GET_PREFERENCES_REQUEST]: getRequest,
  [Types.GET_PREFERENCES_SUCCESS]: getSuccess,
  [Types.GET_PREFERENCES_FAILURE]: getFailure,
  [Types.UPDATE_PREFERENCES_REQUEST]: updateRequest,
  [Types.UPDATE_PREFERENCES_SUCCESS]: updateSuccess,
  [Types.UPDATE_PREFERENCES_FAILURE]: updateFailure,
};

export default resettableReducer(loginTypes.LOGOUT)(createReducer(INITIAL_STATE, HANDLERS));
